export const CONTENT_RULE: ValidationRule = {
  id: 'jps-content',
  strict: true,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'ItemのIDないしは組織に基づくID',
        en: ''
      }
    },
    title: {
      field: 'title',
      type: 'object',
      mandatory: false,
      jaMandatory: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'タイトル',
        en: 'Title'
      }
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    },
    contentsRightsType: {
      field: 'contentsRightsType',
      type: 'string',
      mandatory: true,
      codeKey: 'jps-rights_type',
      label: {
        ja: '権利区分',
        en: 'Rights'
      }
    },
    contentsRights: {
      field: 'contentsRights',
      type: 'object',
      mandatory: false,
      allowHTML: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'a',
        'div',
        'p',
        'i',
        'b',
        'em',
        'blockquote',
        'strong',
        'br',
        'ul',
        'ol',
        'li'
      ],
      objRuleName: 'jps-lang_string',
      label: {
        ja: '権利表示',
        en: 'Attribution'
      }
    },
    source: {
      field: 'source',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '出典',
        en: 'Source'
      }
    },
    sourceUrl: {
      field: 'sourceUrl',
      type: 'string',
      mandatory: false,
      label: {
        ja: '出典URL',
        en: 'Source URL'
      }
    },
    images: {
      field: 'images',
      type: 'array',
      mandatory: false,
      objRuleName: 'jps-image',
      arraySubType: 'object'
    }
  }
}
export const IMAGE_RULE: ValidationRule = {
  id: 'jps-image',
  strict: true,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'ID',
        en: 'ID'
      }
    },
    fileName: {
      field: 'fileName',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'ファイル名',
        en: 'File Name'
      }
    },
    width: {
      field: 'width',
      type: 'number',
      mandatory: true,
      numIntOnly: true,
      label: {
        ja: '幅',
        en: 'Width'
      }
    },
    height: {
      field: 'height',
      type: 'number',
      mandatory: true,
      numIntOnly: true,
      label: {
        ja: '高さ',
        en: 'Height'
      }
    },
    digest: {
      field: 'digest',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'ファイルのダイジェスト',
        en: 'Digest'
      }
    }
  }
}
